import { ICommandBase } from '@/commands/interface/iCommandBase';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';

// 曲線の制御点削除コマンド
export class RemoveControlPointFromCurveCommand implements ICommandBase
{
    private layer! : CurveLayer;
    private index! : number;
    private doneCallback! : () => void;

    private oldX : number = 0;
    private oldY : number = 0;

    constructor(layer : CurveLayer, index : number, doneCallback : () => void)
    {
        this.layer = layer;
        this.index = index;
        this.doneCallback = doneCallback;

        // 現在の制御点の座標
        var controlPoint = layer.getControlPoint(index);
        this.oldX = controlPoint.x;
        this.oldY = controlPoint.y;
    }

    public do() : void
    {
        // 制御点を削除
        this.layer.removeControlPoint(this.index);

        this.doneCallback();
    }

    public undo() : void
    {
        // 制御点を追加
        this.layer.insertControlPoint(this.index, this.oldX, this.oldY);

        this.doneCallback();
    }

    public redo() : void
    {
        // 制御点を削除
        this.layer.removeControlPoint(this.index);

        this.doneCallback();
    }
}